import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'business-list.list-view.sprint-cell.popup-content.placeholder',
		defaultMessage: 'Select sprint',
		description: 'Placeholder text for sprint select component',
	},
	cannotLoadSprintSuggestions: {
		id: 'business-list.list-view.sprint-cell.popup-content.cannot-load-sprint-suggestions',
		defaultMessage: "Couldn't load the sprints.",
		description: 'Message shown when we failed to load sprints from backend',
	},
	cannotEditSubtasks: {
		id: 'business-list.list-view.sprint-cell.popup-content.cannot-edit-subtasks',
		defaultMessage: 'Subtasks remain in the same sprint as their parent task.',
		description: 'Message shown when the user is not able to update the sprint field for a subtask',
	},
});
